<template>
  <div>
    <v-form
      v-model="validation"
      ref="form"
      @submit.prevent="title === 'Crear' ? createExpense() : editExpense()"
    >
      <v-container>
        <Title :title="title + ' gasto'" class="mb-10" />
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Fecha"
                  readonly
                  outlined
                  :value="formattedDate"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.date"
                locale="es-ES"
                color="primary"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.location"
              :items="locations"
              label="Sede *"
              item-value="id"
              :item-text="(value) => value.name"
              :rules="rules.required"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.description"
              type="text"
              label="Descripción *"
              :rules="rules.default"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <vuetify-money
              v-model="form.total"
              label="Importe"
              placeholder="0.00"
              :outlined="true"
              :clearable="true"
              :backgroundColor="
                $vuetify.theme.currentTheme.vuetifyMoneyBackground
              "
              :options="{
                locale: 'ja-JP',
                prefix: 'RD$. ',
                suffix: '',
                length: 9,
                precision: 2,
              }"
              :properties="{
                hint: '',
              }"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="form.comment"
              type="text"
              label="Comentarios"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              depressed
              small
              color="primary"
              class="pa-5"
              type="submit"
              :disabled="!validation"
              :loading="loading"
            >
              {{ title }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import axios from "axios";
import Title from "../Title.vue";
import moment from "moment";

export default {
  name: "ExpenseForm",
  components: {
    Title,
  },
  props: ["title", "expense"],
  data() {
    return {
      dateMenu: false,
      form: {
        description: "",
        total: "",
        comment: "",
        location: "",
        date: "",
      },
      rules: {
        default: [
          (v) => !!v || "Campo obligatorio",
          (v) => (v && v.length <= 100) || "Debe tener menos de 100 caracteres",
        ],
        required: [(v) => !!v || "Campo obligatorio"],
      },
      validation: true,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentLocation", "locations"]),
    formattedDate() {
      return this.form.date
        ? moment(this.form.date).format("DD/MM/YYYY")
        : moment().format("DD/MM/YYYY");
    },
  },
  methods: {
    ...mapMutations(["pushExpense", "setAlert", "updateExpense"]),
    async createExpense() {
      try {
        this.loading = true;
        const res = await axios.post("/api/expense", {
          ...this.form,
          doctorId: this.currentUser.doctor.id,
        });
        const { item, message } = res.data;
        this.pushExpense(item);
        this.setAlert({
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          timeout: 4000,
          text: message,
        });
        this.$refs.form.reset();
        this.$emit("expense-created", item);
      } catch (error) {
        console.log(error);
        this.setAlert({
          show: true,
          color: "error",
          icon: "mdi-alert-remove",
          text: error.response.data.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async editExpense() {
      try {
        this.loading = true;
        const res = await axios.put(`/api/expense/${this.expense.id}`, {
          id: this.expense.id,
          ...this.form,
        });
        const { item, message } = res.data;
        this.setAlert({
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          timeout: 4000,
          text: message,
        });
        this.updateExpense(item);
        this.$emit("expense-updated", item);
      } catch (error) {
        console.log(error);
        this.setAlert({
          show: true,
          color: "error",
          icon: "mdi-alert-remove",
          text: error.response.data.message,
        });
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$emit("on-cancel");
    },
  },
  watch: {
    expense: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          Object.assign(this.form, newVal);
        }

        if (this.title === "Crear") {
          this.$refs.form?.reset();
          this.form.total = 0;
          this.form.location =
            this.currentLocation?.id && this.currentLocation.id !== -1
              ? this.currentLocation?.id
              : this.locations[0].id;
        }
      },
    },
  },
};
</script>
